import { change } from 'redux-form';
import { API_METHODS, LOCAL_STORAGE_KEYS } from 'config/constants';
import {
  writeToLocalState,
  getFromLocalState,
  clearLocalState,
} from 'utils/localStorage';

export const AUTH_ACTION_TYPES = {
  AUTH_LOGIN: 'AUTH_LOGIN',
  AUTH_LOGOUT: 'AUTH_LOGOUT',
  AUTH_UPDATE_TOKENS: 'AUTH_UPDATE_TOKENS',
  AUTH_UPDATE_AUTH_INFO: 'AUTH_UPDATE_AUTH_INFO',
  AUTH_CHANGE_PROCESSING: 'AUTH_CHANGE_PROCESSING',
  AUTH_STUDIES_COUNT: 'AUTH_STUDIES_COUNT',
  AUTH_CHECK_INVITE: 'AUTH_CHECK_INVITE',
};

export function login(body) {
  return async (dispatch, getState, { getAxios, getListAxios }) => {
    const axios = getAxios();

    dispatch(changeAuthProcessingState(true));

    const response = await axios.post(API_METHODS.AUTH_LOGIN, body);

    dispatch(changeAuthProcessingState(false));

    if (!response || response.code !== 'success') {
      return response;
    }

    const { data } = response;

    writeToLocalState(LOCAL_STORAGE_KEYS.USER, data);

    dispatch({
      type: AUTH_ACTION_TYPES.AUTH_LOGIN,
      payload: {
        ...data,
      },
    });

    return response;
  };
}

export function resendMFAValidationCode() {
  return async (dispatch, getState, { getAxios, getListAxios }) => {
    const axios = getAxios();

    dispatch(changeAuthProcessingState(true));

    const response = await axios.post(
      API_METHODS.AUTH_MFA_RESEND_VALIDATION_CODE,
    );

    dispatch(changeAuthProcessingState(false));

    if (!response || response.code !== 'success') {
      return response;
    }

    return response;
  };
}

export function validateMFACode(payload) {
  return async (dispatch, getState, { getAxios, getListAxios }) => {
    const axios = getAxios();

    dispatch(changeAuthProcessingState(true));

    const response = await axios.post(
      API_METHODS.AUTH_MFA_VALIDATE_CODE,
      payload,
    );

    dispatch(changeAuthProcessingState(false));

    if (!response || response.code !== 'success') {
      return response;
    }

    const { data } = response;

    writeToLocalState(LOCAL_STORAGE_KEYS.USER, data);

    dispatch({
      type: AUTH_ACTION_TYPES.AUTH_LOGIN,
      payload: {
        ...data,
      },
    });

    return response;
  };
}

export function signUp(body) {
  return async (dispatch, getState, { getAxios, getListAxios }) => {
    const axios = getAxios();

    dispatch(changeAuthProcessingState(true));

    const response = await axios.post(API_METHODS.REG_SHORT, body);

    dispatch(changeAuthProcessingState(false));

    if (!response || response.code !== 'success') {
      return response;
    }

    const { data } = response;

    writeToLocalState(LOCAL_STORAGE_KEYS.USER, data);

    dispatch({
      type: AUTH_ACTION_TYPES.AUTH_LOGIN,
      payload: {
        ...data,
      },
    });

    return response;
  };
}

export function restoreUserStateFromLocalStorage() {
  const userState = getFromLocalState(LOCAL_STORAGE_KEYS.USER);
  const studiesCount = getFromLocalState(LOCAL_STORAGE_KEYS.STUDIES_COUNT);

  return {
    type: AUTH_ACTION_TYPES.AUTH_LOGIN,
    payload: {
      ...userState,
      studiesCount,
    },
  };
}

export function loginAdmin() {
  return {
    type: AUTH_ACTION_TYPES.AUTH_LOGIN,
    payload: {
      isAdmin: true,
    },
  };
}

export function logout() {
  clearLocalState(LOCAL_STORAGE_KEYS.USER);
  clearLocalState(LOCAL_STORAGE_KEYS.STUDIES_COUNT);
  clearLocalState(LOCAL_STORAGE_KEYS.BREADCRUMBS_ARRAY);

  return {
    type: AUTH_ACTION_TYPES.AUTH_LOGOUT,
  };
}

// TODO deprecated, not used
export function logoutRequest() {
  return (dispatch, getState, { getAxios, getListAxios }) => {
    const axios = getAxios();
    axios.put(API_METHODS.AUTH_LOGOUT);
  };
}

export function updateTokens(newTokensInfo) {
  const userState = getFromLocalState(LOCAL_STORAGE_KEYS.USER);
  const newUserState = {
    ...userState,
    ...newTokensInfo,
  };
  writeToLocalState(LOCAL_STORAGE_KEYS.USER, newUserState);
  return {
    type: AUTH_ACTION_TYPES.AUTH_UPDATE_TOKENS,
    payload: newTokensInfo,
  };
}

export function getNewAuthInfo() {
  return async (dispatch, getState, { getAxios, getListAxios }) => {
    const axios = getAxios();

    const response = await axios.get(`${API_METHODS.USER}`);

    if (!response || response.code !== 'success') {
      return response;
    }

    const { data } = response;

    dispatch(rewriteAuthInfo(data));

    return response;
  };
}

export function rewriteAuthInfo(newAuthInfo) {
  const userState = getFromLocalState(LOCAL_STORAGE_KEYS.USER);
  const newUserState = {
    ...userState,
    authInfo: {
      ...newAuthInfo,
    },
  };
  writeToLocalState(LOCAL_STORAGE_KEYS.USER, newUserState);
  return {
    type: AUTH_ACTION_TYPES.AUTH_UPDATE_AUTH_INFO,
    payload: newAuthInfo,
  };
}

export function changeAuthProcessingState(newState) {
  return {
    type: AUTH_ACTION_TYPES.AUTH_CHANGE_PROCESSING,
    payload: newState,
  };
}

export function checkInviteId(token) {
  return async (dispatch, getState, { getAxios, getListAxios }) => {
    const axios = getAxios();
    const response = await axios.get(`${API_METHODS.INACTIVE_INVITE(token)}`);

    if (!response || response.code !== 'success') {
      dispatch(rewriteAuthInfo({ inviteData: {} }));

      return response;
    }

    const { data } = response;

    dispatch(rewriteAuthInfo({ inviteData: data }));
    dispatch(change('signUpForm', `email`, data.email));
    dispatch(change('signUpForm', `firstName`, data.firstName));
    dispatch(change('signUpForm', `lastName`, data.lastName));
    dispatch(change('signUpForm', `invitedUserId`, data.id));

    return response;
  };
}

export function clearInviteData() {
  return async (dispatch, getState, { getAxios, getListAxios }) => {
    dispatch(rewriteAuthInfo({ inviteData: {} }));
    dispatch(change('signUpForm', `email`, ''));
    dispatch(change('signUpForm', `invitedUserId`, ''));
  };
}
